import PropTypes from 'prop-types';
import { createContext, useContext, useState } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Avatar, Box, ButtonBase } from '@mui/material';

// project imports
import LogoSection from '../LogoSection';
import SearchSection from './SearchSection';
import ProfileSection from './ProfileSection';
import NotificationSection from './NotificationSection';
import axios from 'axios';

// assets
import { IconMenu2 } from '@tabler/icons';
import { useEffect } from 'react';
import DisplayRazorpay from 'payment/Payment';
import { UserContext } from 'ContextFiles';
import { WindowSharp } from '@mui/icons-material';


// ==============================|| MAIN NAVBAR / HEADER ||============================== //

const Header = ({ handleLeftDrawerToggle }) => {
    const theme = useTheme();
    const [reset, setReset] = useState(false)
    const {user}=useContext(UserContext)
    console.log(user)
    const idArr=location.search.split("=");
    var state=true;
        useEffect(async ()=>{
            
            const courseIds = await axios({
                url: process.env.REACT_APP_URL + '/db/getcourseslms',
                // url: "http://localhost:8081/db/getcourses",
                method: "POST",
                data: {
                    token: user.idToken, 
                    userId: user.id
                }
            })
            let arr=courseIds.data.data
            console.log(arr);
            for(let key in arr){
                if(arr[key]==idArr[1]){
                    console.log(state)
                    state=false;
                    console.log(state)
                }
            }
            const response=await axios({
                method:"post",
                url:'https://cms.keewesolutions.com/wp/checkCourse',
                data:{
                    'courseId':idArr[1]
                }
            }).catch(err=>console.log(err))
            console.log(state);
            if(response!=undefined){
            if(response.data==false){
                alert("Course with specified course Id does not exist")
            }
            else  if(idArr[0]==='?courseId' & state){
                console.log("!")
                console.log(user.id)
                const paymentData=await DisplayRazorpay(user.id,user.name,user.email,user.phone,idArr[1]);
                console.log(paymentData);
                setReset(!reset)
            }
        }  
        },[])
    
    return (
        <>
            {/* logo & toggler button */}
            <Box
                sx={{
                    width: 228,
                    display: 'flex',
                    [theme.breakpoints.down('md')]: {
                        width: 'auto'
                    }, 
                    
                }}
            >
                <Box component="span" sx={{ display: { xs: 'none', md: 'block' }, flexGrow: 1 }}>
                    <LogoSection  />
                </Box>
                <ButtonBase sx={{ borderRadius: '12px', overflow: 'hidden' }}>
                    <Avatar
                        variant="rounded"
                        sx={{
                            ...theme.typography.commonAvatar,
                            ...theme.typography.mediumAvatar,
                            transition: 'all .2s ease-in-out',
                            background: theme.palette.secondary.light,
                            color: theme.palette.secondary.dark,
                            '&:hover': {
                                background: theme.palette.secondary.dark,
                                color: theme.palette.secondary.light
                            }
                        }}
                        onClick={handleLeftDrawerToggle}
                        color="inherit"
                    >
                        <IconMenu2 stroke={1.5} size="1.3rem" />
                    </Avatar>
                </ButtonBase>
            </Box>

            {/* header search */}
            {/* <SearchSection /> */}
            <Box sx={{ flexGrow: 1 }} />
            <Box sx={{ flexGrow: 1 }} />

            {/* notification & profile */}
            {/* <NotificationSection /> */}
            <ProfileSection />
            </>
    );
};

Header.propTypes = {
    handleLeftDrawerToggle: PropTypes.func
};

export default Header;
